import React from 'react';
import './styles/AuthScreen.css';
import { useNavigate } from 'react-router-dom';
import { auth, googleProvider } from '../firebase/config';
import { signInWithPopup } from 'firebase/auth';
import google_icon from '../assets/images/google-icon.png';
import area51video from '../assets/images/area51video.mp4';

const AuthScreen = () => {
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const userData = {
        email: user.email,
        name: user.displayName,
        photoURL: user.photoURL,
      };

      // ✅ Redirect to location screen with user data
      navigate('/locationscreen', { state: { user: userData } });

    } catch (error) {
      console.error('❌ Google login failed:', error.message);
      alert('Google Sign-In Failed. Please try again.');
    }
  };

  return (
    <div className="auth-container">
      <h2 className="auth-heading">
        Check out this demo video to<br />see how the app works
      </h2>

      <div className="video-thumbnail">
        <video className="video-element" controls playsInline>
          <source src={area51video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="google-login" onClick={handleGoogleLogin}>
        <img src={google_icon} alt="Google" className="google-icon" />
        <span>Login With Google</span>
      </div>
       {/* <div className="separator">OR</div> */}

      {/* Phone Login UI (optional) */}
      {/* <input type="tel" placeholder="Enter Phone No." className="input-box" />
      <button className="generate-otp-btn">Generate OTP</button>
      <input type="text" placeholder="Enter OTP" className="input-box" />
      <button className="login-btn">Log In</button> */}

      {/* <p className="new-user-text">New to App?</p>
      <button className="create-account-btn">Create an account</button> */}
  
    </div>
  );
};

export default AuthScreen;
